import Spinner from "../../components/Spiner/Spinner";
import styles from "./PlansPage.module.scss"
import {useEffect, useState} from "react";
import {IPackage} from "../../models/Package";
import PlanItem from "../../components/PlanItem/PlanItem";
import useAppSelector from "../../hooks/useAppSelector";
import {useQuery} from "../../hooks/useQuery";
import StripeElements from "../../components/StripeElements/StripeElements";
import Check3DSecurePayment from "../../components/Check3DSecurePayment/Check3DSecurePayment";

const PlansPage = () => {
    const query = useQuery();

    const [paymentIntentId] = useState(query.get("payment_intent_client_secret"));
    const {packages, packagesLoading} = useAppSelector(state => state.packageSlice);
    const [filteredPackages, setFilteredPackages] = useState<IPackage[]>([]);
    const {content} = useAppSelector(state => state.siteContentSlice);

    useEffect(() => {
        if (content.plansItemsForPlansPage && packages.length) {
            const result: IPackage[] = [];
            packages.forEach(el => {
                const itemForPlansPage = content.plansItemsForPlansPage.find(x => x.packageId === el.id);
                if (!itemForPlansPage) return result.push(el);
                if (!itemForPlansPage.visibleOnPlansPage) return;
                const filteredOptions = el.options.filter(el => el.visible);
                result.push({
                    ...el,
                    options: filteredOptions,
                    description: itemForPlansPage.description
                })
            })
            setFilteredPackages(result);
        }
    }, [content, packages]);

    if (packagesLoading) {
        return (
            <Spinner/>
        )
    }

    return (
        <section className={styles.page}>
            <div className="container">
                <div className={styles.wrapper}>
                    {filteredPackages.map(el => {
                        return (
                            <PlanItem
                                key={el.id}
                                item={el}
                            />
                        )
                    })}
                </div>
            </div>
            {
                paymentIntentId && (
                    <StripeElements>
                        <Check3DSecurePayment
                            fromUrl={"/plans"}
                            paymentIntentId={paymentIntentId}
                        />
                    </StripeElements>
                )
            }
        </section>
    )
}

export default PlansPage;